import { render, staticRenderFns } from "./ConfirmEmail.vue?vue&type=template&id=2ea3e3ef&"
import script from "./ConfirmEmail.vue?vue&type=script&lang=js&"
export * from "./ConfirmEmail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2ea3e3ef')) {
      api.createRecord('2ea3e3ef', component.options)
    } else {
      api.reload('2ea3e3ef', component.options)
    }
    module.hot.accept("./ConfirmEmail.vue?vue&type=template&id=2ea3e3ef&", function () {
      api.rerender('2ea3e3ef', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Components/ConfirmEmail/ConfirmEmail.vue"
export default component.exports